export default __webpack_public_path__ + "static/media/Make Love not War.28832e2e.jpg";